import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

function parseConversationJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:groupTripId|conversationId|bindingId|memberId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseConversationJson] };

/** GroupTrip BUSINESS_GROUP binding — messages stay on IM. */
export const groupTripConversationApi = {
  get: (groupTripId) =>
    travelClient.get(travelEndpoints.groupTripConversation(groupTripId), snowflakeJson),
  ensure: (groupTripId) =>
    travelClient.post(
      travelEndpoints.groupTripConversation(groupTripId),
      { confirm: true },
      snowflakeJson,
    ),
};
